"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerToJSON = exports.StoresInnerFromJSONTyped = exports.StoresInnerFromJSON = exports.instanceOfStoresInner = exports.StoresInnerCreatedViaEnum = void 0;
var runtime_1 = require("../runtime");
var StoresInnerProductsInner_1 = require("./StoresInnerProductsInner");
/**
 * @export
 */
exports.StoresInnerCreatedViaEnum = {
    Internal: 'internal',
    SelfServe: 'self_serve',
    Groups: 'groups'
};
/**
 * Check if a given object implements the StoresInner interface.
 */
function instanceOfStoresInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInner = instanceOfStoresInner;
function StoresInnerFromJSON(json) {
    return StoresInnerFromJSONTyped(json, false);
}
exports.StoresInnerFromJSON = StoresInnerFromJSON;
function StoresInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'urlSlug': !(0, runtime_1.exists)(json, 'url_slug') ? undefined : json['url_slug'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : json['created_at'],
        'createdVia': !(0, runtime_1.exists)(json, 'created_via') ? undefined : json['created_via'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'logoImageUrl': !(0, runtime_1.exists)(json, 'logo_image_url') ? undefined : json['logo_image_url'],
        'storeType': !(0, runtime_1.exists)(json, 'store_type') ? undefined : json['store_type'],
        'placedAt': !(0, runtime_1.exists)(json, 'placed_at') ? undefined : json['placed_at'],
        'canceledAt': !(0, runtime_1.exists)(json, 'canceled_at') ? undefined : json['canceled_at'],
        'targetDate': !(0, runtime_1.exists)(json, 'target_date') ? undefined : json['target_date'],
        'totalCollectedOnline': !(0, runtime_1.exists)(json, 'total_collected_online') ? undefined : json['total_collected_online'],
        'totalItemsQuantity': !(0, runtime_1.exists)(json, 'total_items_quantity') ? undefined : json['total_items_quantity'],
        'totalPurchases': !(0, runtime_1.exists)(json, 'total_purchases') ? undefined : json['total_purchases'],
        'expectedQuantity': !(0, runtime_1.exists)(json, 'expected_quantity') ? undefined : json['expected_quantity'],
        'custominkOrderIds': !(0, runtime_1.exists)(json, 'customink_order_ids') ? undefined : json['customink_order_ids'],
        'campaignState': !(0, runtime_1.exists)(json, 'campaign_state') ? undefined : json['campaign_state'],
        'participantPay': !(0, runtime_1.exists)(json, 'participant_pay') ? undefined : json['participant_pay'],
        'products': !(0, runtime_1.exists)(json, 'products') ? undefined : (json['products'] === null ? null : json['products'].map(StoresInnerProductsInner_1.StoresInnerProductsInnerFromJSON)),
    };
}
exports.StoresInnerFromJSONTyped = StoresInnerFromJSONTyped;
function StoresInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'url_slug': value.urlSlug,
        'created_at': value.createdAt,
        'created_via': value.createdVia,
        'status': value.status,
        'logo_image_url': value.logoImageUrl,
        'store_type': value.storeType,
        'placed_at': value.placedAt,
        'canceled_at': value.canceledAt,
        'target_date': value.targetDate,
        'total_collected_online': value.totalCollectedOnline,
        'total_items_quantity': value.totalItemsQuantity,
        'total_purchases': value.totalPurchases,
        'expected_quantity': value.expectedQuantity,
        'customink_order_ids': value.custominkOrderIds,
        'campaign_state': value.campaignState,
        'participant_pay': value.participantPay,
        'products': value.products === undefined ? undefined : (value.products === null ? null : value.products.map(StoresInnerProductsInner_1.StoresInnerProductsInnerToJSON)),
    };
}
exports.StoresInnerToJSON = StoresInnerToJSON;
